module.exports = __webpack_public_path__ + "static/img/ic_gy_fw_pz.86f7c717.png";